




































































import VueOptions from '@utils/VueOptions'
import DropdownFilter from '@ui/Filters/DropdownFilter'

settings =
  name: 'VenueFilter'

  vue:
    props: ['target', 'actions', 'options']

    components: {
      DropdownFilter,
    }

    data: ->
      selectedPublishedScope: null
      selectedGeofenceScope: null
      selectedTrustedGeofenceScope: null
      selectedCenteredGeofenceScope: null
      selectedUserInformedDatesScope: null

    mounted: ->
      @initializeSelectedFilters()

    computed:
      targetScopes: -> @target.scopes

      selectedScopes: ->
        [
          @selectedPublishedScope
          @selectedGeofenceScope
          @selectedTrustedGeofenceScope
          @selectedCenteredGeofenceScope
          @selectedUserInformedDatesScope
        ].filter(Boolean)

      optionsForPublishedScopeFilter: ->
        [
          { scope: null, label: 'All' }
          { scope: 'has_published_availabilities', label: 'At least one published' }
          { scope: 'has_not_published_availabilities', label: 'Only unpublished' }
        ]

      optionsForGeofenceScopeFilter: ->
        [
          { scope: null, label: 'All' }
          { scope: 'geo_fenced', label: 'Geofenced' }
          { scope: 'not_geo_fenced', label: 'Not geofenced' }
        ]

      optionsForTrustedGeofenceScopeFilter: ->
        [
          { scope: null, label: 'All' }
          { scope: 'geo_fence_trusted', label: 'Trusted' }
          { scope: 'geo_fence_not_trusted', label: 'Not trusted' }
        ]

      optionsForCenteredGeofenceScopeFilter: ->
        [
          { scope: null, label: 'All' }
          { scope: 'geo_fence_centered', label: 'Centered' }
          { scope: 'geo_fence_not_centered', label: 'Not centered' }
        ]

      optionsForUserInformedDatesScopeFilter: ->
        [
          { scope: null, label: 'All' }
          { scope: 'has_personas_with_user_informed_date', label: 'Informed past dates' }
          { scope: 'has_personas_without_user_informed_date', label: 'Generated past dates' }
        ]

    methods:
      initializeSelectedFilters: ->
        @selectedPublishedScope = @initialScopeFromOptionsOrDefault @optionsForPublishedScopeFilter
        @selectedGeofenceScope = @initialScopeFromOptionsOrDefault @optionsForGeofenceScopeFilter
        @selectedUserInformedDatesScope = @initialScopeFromOptionsOrDefault @optionsForUserInformedDatesScopeFilter

      hiClearPublishedScopeFilter: ->
        @selectedPublishedScope = null
        @applyFilters()

      hiClearGeofenceScopeFilter: ->
        @selectedGeofenceScope = null
        @applyFilters()

      hiClearUserInformedDatesScopeFilter: ->
        @selectedUserInformedDatesScope = null
        @applyFilters()

      hiApplyFilters: ->
        @applyFilters { force: true }

      applyFilters: ({ force }) ->
        changed = false

        unless @objectsAreEqual(@target.scopes, @selectedScopes)
          @target.scopes = @selectedScopes
          changed = true

        @actions.hiApplyFilters() if force or changed

      initialScopeFromOptionsOrDefault: (options) ->
        scopesFromOptions = @pluck options, 'scope'
        scope = @targetScopes.find((scope) => scope in scopesFromOptions)
        scope ||= null

export default VueOptions.vue settings
